import { Dimension, ResponsiveDimension } from "../../../types";

type Args = {
  collapseOnMobile: boolean;
  collapseOnTablet: boolean;
  reverseOnCollapse?: boolean;
};

// This is needed to remove padding from the first child that a user sees,
//  another way of achieving this is leaving all the paddings as the same
//  and applying negative margins in the parent `Columns` component
// e.g. if you have
// <Columns collapseBelow='desktop' reverseOnCollapse>
//   <ChildColumn1/>
//   <ChildColumn2/>
// </Columns>
// then on desktop the order looks like
// <ChildColumn1/>
// <ChildColumn2/>
// but on tablet it'll look like the order of columns appears to be
// <ChildColumn2/>
// <ChildColumn1/>

export function removePaddingFromVisuallyFirst({
  collapseOnMobile,
  collapseOnTablet,
  reverseOnCollapse
}: Args) {
  if (reverseOnCollapse) {
    return {
      firstChildStyles: {
        paddingLeft: [
          collapseOnMobile ? null : "none",
          collapseOnTablet ? null : "none",
          "none"
        ] as ResponsiveDimension,
        paddingTop: [
          collapseOnMobile ? null : "none",
          collapseOnTablet ? null : "none",
          "none"
        ] as ResponsiveDimension
      },
      lastChildStyles: {
        paddingLeft: [
          collapseOnMobile ? "none" : null,
          collapseOnTablet ? "none" : null,
          null
        ] as ResponsiveDimension,
        paddingTop: [
          collapseOnMobile ? "none" : null,
          collapseOnTablet ? "none" : null,
          null
        ] as ResponsiveDimension
      }
    };
  }

  return {
    firstChildStyles: {
      paddingLeft: "none" as Dimension,
      paddingTop: "none" as Dimension
    }
  };
}
